/*=================================================
    summary: 老師 看 / 改 學生考卷 拼音 填空題 Pinyin Dictation 單元

    remarks: 000 Tim 2021/12/01 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentPinyinDictation from './AssignmentPinyinDictation.module.scss'
import {GlobalLibs} from 'bc-react-package'

// #region State Member Variables
let marrStateFeedbackText = []
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let marrDisplayQuestion = []
// #endregion Member Variables

// #region Const
const MAX_FEEDBACK_CHARACHERS = 300 // Textarea最大的數字限制
// #endregion Const


const COMP_NAME = "AssignmentPinyinDictation"

function AssignmentPinyinDictation(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [playAudioIndex, setPlayAudioIndex] = useState(-1)
    const [feedbackTextArray, setFeedbackTextArray] = useState([])
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        RegisterGetTeacherFeedback()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update feedbackTextArray
    useEffect(() => {
        marrStateFeedbackText = feedbackTextArray

        console.log(COMP_NAME + ".Update feedbackTextArray: marrStateFeedbackText: ", marrStateFeedbackText)    
    }, [feedbackTextArray])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.StopAudio()

            mblnInitialized = false

            setUpdateDataTime(0)
        }
    }, [])

    // #region OnTapHandler
    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioFN, QuestionIndex)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setPlayAudioIndex(QuestionIndex)
        
        let strAudioUrl = window.Globals.GetResourceUrl(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFN)
        window.AudioLibs.PlayAudio(strAudioUrl)
    } // end of AudioPlayOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        setPlayAudioIndex(-1)
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: Feedback 改變 事件
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function FeedbackChangeHandler(e, StateFeedbackTextArray, QuestionIndex)
    {
        // console.log(COMP_NAME + ".FeedbackChangeHandler: e.target.value:", e.target.value)
        let arrFeedbackText = JSON.parse(JSON.stringify(StateFeedbackTextArray))
        arrFeedbackText[QuestionIndex] = e.target.value
        setFeedbackTextArray(arrFeedbackText)
    } // end of FeedbackChangeHandler
    // #endregion Other EventHandler

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)

        marrDisplayQuestion = FormatPDQuestionData(props.LearningUnitData, props.TeacherAssignmentData)
        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: 註冊 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RegisterGetTeacherFeedback ()
    {
        let objCallbackData = {
            "Action": "RegisterGetTeacherFeedback",
            "Function": GetTeacherFeedback
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterGetTeacherFeedback

    /*===========================================
    summary: 取得 老師 打分 資料
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function GetTeacherFeedback ()
    {
        let objTeacherFeedback = null
        let arrTeacherFeedback = []
        let intIndex = 0
        let intCount = marrDisplayQuestion.length

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            objTeacherFeedback = {
                "AnswerID": marrDisplayQuestion[intIndex].AnswerID,
                "SentenceSeqNo": marrDisplayQuestion[intIndex].SentenceSeqNo,
                "TeacherFeedbackText": ""
            }
            if (
                (typeof(marrStateFeedbackText[intIndex]) !== 'undefined') &&
                (marrStateFeedbackText[intIndex] !== null) &&
                (marrStateFeedbackText[intIndex] !== "") 
                )
            {
                objTeacherFeedback.TeacherFeedbackText = marrStateFeedbackText[intIndex]
            }

            arrTeacherFeedback.push(objTeacherFeedback)
        } // end of for (intIndex = 0;

        return arrTeacherFeedback
    } // end of GetTeacherFeedback
    
    /*===========================================
    summary: 初始化 拼音 填空題 答案資料
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function FormatPDQuestionData(LearningUnit, TeacherAssignment)
    {
        console.log(COMP_NAME + ".FormatPDQuestionData: ", LearningUnit, TeacherAssignment);

        let arrDisplaySentence = JSON.parse(JSON.stringify(LearningUnit.Sentence))
        let intSCount = LearningUnit.Sentence.length
        let arrAnswer = []
        let intNAIndex = 0

        let strTeacherFeedbackText = ""
        let arrTeacherFeedbackText = []

        let objAnswer = null
        let blnFinished = false

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
        }

        LearningUnit.Sentence.find(function(SentenceData, SentenceIndex)
        {
            objAnswer = arrAnswer.find(Answer => parseInt(Answer.SentenceSeqNo) === parseInt(SentenceData.SentenceSeqNo))

            if (
                (typeof(objAnswer) !== 'undefined') &&
                (objAnswer !== null)
                )
            {
                strTeacherFeedbackText = ""

                arrDisplaySentence[SentenceIndex].AnswerID = objAnswer.AnswerID
                arrDisplaySentence[SentenceIndex].SentenceSeqNo = objAnswer.SentenceSeqNo
                arrDisplaySentence[SentenceIndex].PDAnswer = objAnswer.PDAnswer

                if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                {
                    arrDisplaySentence[SentenceIndex].QuestionText = arrDisplaySentence[SentenceIndex].MajorText
                }
                else
                {
                    arrDisplaySentence[SentenceIndex].QuestionText = arrDisplaySentence[SentenceIndex].MinorText
                }

                if (objAnswer.TeacherFeedbackText !== null)
                {
                    arrDisplaySentence[SentenceIndex].TeacherFeedbackText = objAnswer.TeacherFeedbackText
                    strTeacherFeedbackText = objAnswer.TeacherFeedbackText
                }
                arrTeacherFeedbackText.push(strTeacherFeedbackText)
            }

            if (SentenceIndex >= intSCount - 1)
            {
                blnFinished = true
                setFeedbackTextArray(arrTeacherFeedbackText)
            }
            
            return blnFinished
        })

        console.log(COMP_NAME + ".FormatPDQuestionData arrDisplaySentence: ", arrDisplaySentence)

        return arrDisplaySentence
    } // end of FormatPDQuestionData
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 聲音播放按鈕 Cls
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function GetAudioPlayCls(StatePlayAudioIndex, QuestionIndex) 
    {
        let objCls = cssAssignmentPinyinDictation.btnAudioPlay

        if (StatePlayAudioIndex === QuestionIndex)
        {
            objCls = cssAssignmentPinyinDictation.btnAudioPlayDisabled
        }

        return objCls
    } // end of GetAudioPlayCls
    // #endregion Get ClassName

    // #region Render元件            
    /*===========================================
    summary: AudioPlay Cell 顯示Component  
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ComponentAudioPlayCell( {StatePlayAudioIndex, QuestionData, QuestionIndex} )
    {   
        return(
            <div className={GetAudioPlayCls(StatePlayAudioIndex, QuestionIndex)} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex)}/>
        )
    } // end of ComponentAudioPlayCell

    /*===========================================
    summary: No Cell 顯示Component  
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ComponentNoCell( {QuestionIndex} )
    {   
        let strNo = (QuestionIndex + 1).toString() + "."

        return(
            <div className={cssAssignmentPinyinDictation.divNoCell}>
                {strNo}
            </div>
        )
    } // end of ComponentNoCell
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Teacher Feedback 觀看結果模式 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderTeacherFeedbackResultWrapper(QuestionData)
    {
        return (
            <div className={cssAssignmentPinyinDictation.divSuggestedTeacherFeedbackMain}>
                <div className={cssAssignmentPinyinDictation.divSuggestedTeacherFeedbackTitle}>
                    {window.gAppUI.LBL_TeachersComments}:
                </div>
                <div className={cssAssignmentPinyinDictation.divFeedback4Result}>
                    {QuestionData.TeacherFeedbackText}
                </div>
            </div>
        )
    } // end of RenderTeacherFeedbackResultWrapper

    /*===========================================
    summary: Render Teacher Feedback 打分數模式 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderTeacherFeedback4ScoreItWrapper(QuestionIndex)
    {
        return (
            <div className={cssAssignmentPinyinDictation.divSuggestedTeacherFeedbackMain}>
                <div className={cssAssignmentPinyinDictation.divSuggestedTeacherFeedbackTitle}>
                    {window.gAppUI.LBL_AddComments}
                </div>

                <label htmlFor="textareaFeedback" className={cssAssignmentPinyinDictation.divHidden}>
                    {window.gAppUI.LBL_WritingCommentsPlaceHolder}
                </label>
                <textarea id="textareaFeedback"
                    className={cssAssignmentPinyinDictation.txtFeedback} 
                    value={feedbackTextArray[QuestionIndex]}
                    placeholder={window.gAppUI.LBL_WritingCommentsPlaceHolder} 
                    maxLength={MAX_FEEDBACK_CHARACHERS}
                    onChange={(event) => FeedbackChangeHandler(event, feedbackTextArray, QuestionIndex)}
                />
            </div>
        )
    } // end of RenderTeacherFeedback4ScoreItWrapper

    /*===========================================
    summary: Render Teacher Feedback 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderTeacherFeedbackWrapper(QuestionData, QuestionIndex, AssignReportStatus)
    {
        if (AssignReportStatus === window.gAssignReportStatusEnum.TeacherScore)
        {
            return RenderTeacherFeedback4ScoreItWrapper(QuestionIndex)
        }
        else
        {
            return RenderTeacherFeedbackResultWrapper(QuestionData)
        }
    } // end of RenderTeacherFeedbackWrapper

    /*===========================================
    summary: Render Answer Cell 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderAnswerCellWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentPinyinDictation.divAnswerCell}>
                <div className={cssAssignmentPinyinDictation.divAnswerText}>
                    {QuestionData.PDAnswer}
                </div>

                <div className={cssAssignmentPinyinDictation.divSuggestedAnswerTitle}>
                    {window.gAppUI.LBL_SuggestedAnswer}
                </div>

                <div className={cssAssignmentPinyinDictation.divSuggestedAnswerText}>
                    {QuestionData.QuestionText}
                </div>

                {RenderTeacherFeedbackWrapper(QuestionData, QuestionIndex, props.AssignReportStatus)}
            </div>
        )
    } // end of RenderAnswerCellWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionData, QuestionIndex)
    {
        return (
            <>
                <ComponentNoCell QuestionIndex={QuestionIndex} />

                <ComponentAudioPlayCell StatePlayAudioIndex={playAudioIndex} QuestionData={QuestionData} QuestionIndex={QuestionIndex} />

                {RenderAnswerCellWrapper(QuestionData, QuestionIndex)}

                <div className={cssAssignmentPinyinDictation.divSpacerCell}/>
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentPinyinDictation.divContent}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                        <div key={QuestionIndex} className={cssAssignmentPinyinDictation.divQuestionMain}>
                            {RenderQuestionUnitWrapper(QuestionData, QuestionIndex)}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentPinyinDictation.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentPinyinDictation